var map = {
	"./噪声有害.png": "aSPw",
	"./当心中毒.png": "5iAu",
	"./当心弧光.png": "yWcw",
	"./当心感染.png": "Y/p1",
	"./当心有毒气体.png": "otr2",
	"./当心电离辐射.png": "c2z6",
	"./当心腐蚀.png": "+T1w",
	"./戴护耳器.png": "I/dX",
	"./戴防尘口罩.png": "728/",
	"./戴防护手套.png": "NElj",
	"./戴防护镜.png": "7J1z",
	"./戴防毒面具.png": "IzMH",
	"./注意通风.png": "rhYi",
	"./注意防尘.png": "ALg5",
	"./注意高温.png": "KBBu",
	"./穿防护服.png": "TZMx",
	"./穿防护鞋.png": "E/2J"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XmOU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign ^\.\/.*\.png$
// module id = XmOU
// module chunks = 1